import tw from "twin.macro"
import styled from "@emotion/styled/macro"
import { css } from "@emotion/react/macro"

const styles = {
  default: tw`flex items-center -mx-1`,
  align: {
    default: tw`justify-center`,
    start: tw`justify-start`,
    end: tw`justify-end`,
  },
  large: css`
    ${tw`-mx-1.5`}

    > *, > .swiper-pagination-bullet {
      ${tw`w-2.5 h-2.5 mx-1.5`}
    }
  `,
  indicator: tw`mx-1 rounded-full w-2 h-2 bg-grey-light hover:bg-teal-dark cursor-pointer opacity-100 transition-colors duration-200`,
  active: tw`bg-navy hover:bg-navy`,
  activeWhite: tw`bg-white hover:bg-white`,
}

export const StyledIndicators = styled.nav`
  ${styles.default}
  ${({ align }) => (align && styles.align[align]) || styles.align[`default`]}

  &.swiper-pagination-bullets > * {
    ${styles.indicator}

    &.swiper-pagination-bullet-active {
      ${styles.activeWhite}
    }
  }

  ${({ large }) => large && styles.large}
`
export const StyledIndicator = styled.div`
  ${styles.indicator}
  ${({ active }) => active && styles.active}
`
